import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const Attribute = ({ label, value }: { label: string; value: any }) => {
    const theme = useTheme()
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: '8px 0',
            }}
        >
            <Box
                sx={{
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: '#9b9b9b',
                    padding: '4px 0px',
                    textTransform: 'uppercase',
                }}
            >
                {label}
            </Box>
            <Box
                sx={{
                    fontSize: '14px',
                    color: theme.palette.common.black,
                    padding: '4px 0px',
                }}
            >
                {value}
            </Box>
        </Box>
    )
}

export default Attribute
